const limitLength = (value, maxLength) => {
  const text = String(value ?? "");
  return maxLength ? text.slice(0, maxLength) : text;
};

export const sanitizeNonNegativeInput = (value, maxLength) => {
  const text = String(value ?? "");
  if (text.includes("-")) return "";
  return limitLength(text, maxLength);
};

export const sanitizePositiveIntegerInput = (value, maxLength) => {
  const text = String(value ?? "");
  if (text.includes("-")) return "";
  const integerPart = text.replace(",", ".").split(".")[0];
  return limitLength(integerPart.replace(/\D/g, ""), maxLength);
};

export const asNonNegativeNumberString = (value, fallback = "") => {
  if (value === undefined || value === null || value === "") return fallback;
  const number = Number(String(value).replace(",", "."));
  if (!Number.isFinite(number)) return fallback;
  if (number < 0) return "0";
  return String(value);
};

export const asPositiveIntegerString = (value, fallback = "1") => {
  const number = Number(value);
  if (!Number.isFinite(number) || number < 1) return fallback;
  return String(Math.floor(number));
};
